"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HostViewScoreboard = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const x_charts_1 = require("@mui/x-charts");
function HostViewScoreboard({ choiceStats, }) {
    const theme = (0, material_1.useTheme)();
    const [valuesData, setValuesData] = (0, react_1.useState)([]);
    const [choiceData, setChoiceData] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        if (choiceStats.length === 0) {
            return;
        }
        setChoiceData(choiceStats.map(stats => stats.choice));
        const totalCount = choiceStats.reduce((acc, stats) => acc + stats.playerCount, 0);
        const percentages = choiceStats.map(stats => totalCount > 0 ? Math.round((stats.playerCount / totalCount) * 100) : 0);
        setValuesData(percentages);
    }, [choiceStats]);
    return (react_1.default.createElement("div", { className: "border border-[#FFFFFF29] rounded-[16px] flex flex-col gap-[1.5rem] px-[1rem] py-[0.5rem] w-full" },
        react_1.default.createElement(material_1.Typography, { sx: {
                color: 'white',
                fontFamily: 'Bryant',
                fontSize: '1.25rem',
                fontWeight: 700,
                lineHeight: '160%',
                letterSpacing: '0.00938rem',
            } }, "Scoreboard"),
        react_1.default.createElement(x_charts_1.BarChart
        // sx={{
        //   display: {
        //     xs: 'none',
        //     sm: 'block',
        //   },
        // }}
        , { 
            // sx={{
            //   display: {
            //     xs: 'none',
            //     sm: 'block',
            //   },
            // }}
            xAxis: [
                {
                    scaleType: 'band',
                    data: choiceData,
                    tickPlacement: 'middle',
                    tickLabelPlacement: 'middle',
                    colorMap: {
                        type: 'ordinal',
                        values: choiceData,
                        colors: [theme.palette.success.main, '#BBDEFB'],
                    },
                    categoryGapRatio: 0.05,
                },
            ], yAxis: [
                {
                    min: 0,
                    max: 100,
                    tickInterval: [0, 20, 40, 60, 80, 100],
                    valueFormatter(value) {
                        if (value === 0) {
                            return `${value}`;
                        }
                        else {
                            return `${value}%`;
                        }
                    },
                },
            ], series: [
                {
                    data: valuesData,
                },
            ], layout: "vertical", slotProps: {
                axisLabel: {
                    style: {
                        fill: 'white',
                    },
                },
                axisLine: {
                    style: {
                        stroke: 'white',
                        strokeWidth: 0,
                    },
                },
                axisTick: {
                    style: {
                        stroke: 'white',
                        strokeWidth: 0,
                    },
                },
                axisTickLabel: {
                    style: {
                        fill: 'white',
                    },
                },
            }, height: 230 })));
}
exports.HostViewScoreboard = HostViewScoreboard;
